import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { BouSpacingLevel, fluidHorizontalPadding } from '@upright/ui/common/generic/layout/bou-spacing';
import { MobileOnly, mobileOrNarrower } from '@upright/ui/common/generic/layout/breakpoint-utils';
import styled, { css } from 'styled-components';
import { SdgAlignmentValence } from '../../../../../../../../common/model/output/scores/sdg-alignment/types';
import { SdgLegendItems } from './sdg-legend-items';

export const SdgLegend = () => {
  return (
    <Root>
      <MobileOnly>
        <MobileExplanation>% of revenue</MobileExplanation>
      </MobileOnly>
      <LegendArea>
        <SdgLegendItems valence={SdgAlignmentValence.MISALIGNED} />
        <SdgLegendItems valence={SdgAlignmentValence.ALIGNED} />
      </LegendArea>
    </Root>
  );
};

const Root = styled.div`
  ${fluidHorizontalPadding(BouSpacingLevel.TINYISH)}
  ${getTextStyle({ size: 'xxs' })}
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding-top: 0em;
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};
  ${mobileOrNarrower(css`
    display: block;
    border-bottom: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
    padding-bottom: 1.5em;
  `)}
`;

const MobileExplanation = styled.div`
  ${fluidHorizontalPadding(BouSpacingLevel.TINYISH)}
  margin-bottom: 0.5em;
`;

const LegendArea = styled.div`
  width: 100%;
  display: flex;
  padding-left: 1em;
  padding-right: 1em;
  flex-wrap: wrap;
  @media (min-width: 900px) {
    flex-wrap: nowrap;
  }
  align-items: baseline;
`;
